/*文章接口*/

import {req} from '../utils/request';

export class Feedback {

  /**
   * 获取数据列表
   * @param params
   * @returns {Promise<any|undefined>}
   */
  getList = async(params) => {
    return req.post('user.feedback/getList', params);
  }
 /**
   * 列表 新增
   * @param params
   * @returns {Promise<*|void>}
   */
  add = async (params) => {
    return req.post('user.feedback/add', params);
  }
  /**
   * 列表 编辑
   * @param params
   * @returns {Promise<*|void>}
   */
  edit = async (params) => {
    return req.post('user.feedback/edit', params);
  }

  /**
   * 删除
   * @param params
   * @returns {Promise<*|void>}
   */
  del = async (params) => {
    return req.post('user.feedback/del', params);
  }

  /**
   * 文章状态 显示/隐藏
   * @param params
   * @returns {Promise<*|void>}
   */
  changeStatus = async (params) => {
    return req.post('user.feedback/changeStatus', params);
  }
}

export default new Feedback();
